import { OldApiCaller as ApiCaller } from 'actions/ApiCaller';
import baseAjaxConfig, { savedCardsAjaxConfig, paymentHeaders } from 'actions/BaseAjaxConfig';

const savedCardHeaders = Object.assign({}, paymentHeaders, {
	Accept: 'application/json',
	'Content-Type': 'application/json'
});
delete savedCardHeaders['x-device-source'];

export const GET_SAVED_CARD_TOKEN_REQUEST = 'GET_SAVED_CARD_TOKEN_REQUEST';
export const GET_SAVED_CARD_TOKEN_SUCCESS = 'GET_SAVED_CARD_TOKEN_SUCCESS';
export const GET_SAVED_CARD_TOKEN_ERROR = 'GET_SAVED_CARD_TOKEN_ERROR';

export function getSavedCardTokenRequestAction() {
	return { type: GET_SAVED_CARD_TOKEN_REQUEST };
}

export function getSavedCardTokenErrorAction() {
	return { type: GET_SAVED_CARD_TOKEN_ERROR };
}

export function getSavedCardTokenSuccessAction(data) {
	return { type: GET_SAVED_CARD_TOKEN_SUCCESS, data };
}

export function getSavedCardTokenAction() {
	return dispatch => {
		dispatch(getSavedCardTokenRequestAction());

		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/cards/saved/account-form`,
				acceptErrors: true
			})
		).then(
			json => dispatch(getSavedCardTokenSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(getSavedCardTokenErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

export const GET_SAVED_CARDS_REQUEST = 'GET_SAVED_CARDS_REQUEST';
export const GET_SAVED_CARDS_SUCCESS = 'GET_SAVED_CARDS_SUCCESS';
export const GET_SAVED_CARDS_ERROR = 'GET_SAVED_CARDS_ERROR';

export function getSavedCardRequestAction() {
	return { type: GET_SAVED_CARDS_REQUEST };
}

export function getSavedCardErrorAction() {
	return { type: GET_SAVED_CARDS_ERROR };
}

export function getSavedCardSuccessAction(data) {
	return { type: GET_SAVED_CARDS_SUCCESS, data };
}

export function getSavedCardsAction(payload = {}) {
	return dispatch => {
		dispatch(getSavedCardRequestAction());
		return ApiCaller.post(
			{
				...savedCardsAjaxConfig,
				headers: savedCardHeaders,
				pathname: `viewsavedcards`
			},
			payload
		).then(
			data => dispatch(getSavedCardSuccessAction(data)),
			err => dispatch(getSavedCardErrorAction(err))
		);
	};
}

export const ADD_SAVED_CARDS_REQUEST = 'ADD_SAVED_CARDS_REQUEST';
export const ADD_SAVED_CARDS_SUCCESS = 'ADD_SAVED_CARDS_SUCCESS';
export const ADD_SAVED_CARDS_ERROR = 'ADD_SAVED_CARDS_ERROR';

export function addSavedCardRequestAction() {
	return { type: ADD_SAVED_CARDS_REQUEST };
}

export function addSavedCardErrorAction() {
	return { type: ADD_SAVED_CARDS_ERROR };
}

export function addSavedCardSuccessAction() {
	return { type: ADD_SAVED_CARDS_SUCCESS };
}

export function addSavedCardAction(payload) {
	return dispatch => {
		dispatch(addSavedCardRequestAction());
		return ApiCaller.post(
			{
				...savedCardsAjaxConfig,
				headers: savedCardHeaders,
				pathname: `addcard`,
				acceptErrors: true
			},
			payload
		).then(
			data => dispatch(addSavedCardSuccessAction(data)),
			err => {
				dispatch(addSavedCardErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

export const DELETE_SAVED_CARDS_REQUEST = 'DELETE_SAVED_CARDS_REQUEST';
export const DELETE_SAVED_CARDS_SUCCESS = 'DELETE_SAVED_CARDS_SUCCESS';
export const DELETE_SAVED_CARDS_ERROR = 'DELETE_SAVED_CARDS_ERROR';

export function deleteSavedCardRequestAction() {
	return { type: DELETE_SAVED_CARDS_REQUEST };
}

export function deleteSavedCardErrorAction() {
	return { type: DELETE_SAVED_CARDS_ERROR };
}

export function deleteSavedCardSuccessAction() {
	return { type: DELETE_SAVED_CARDS_SUCCESS };
}

export function deleteSavedCardAction(payload) {
	return dispatch => {
		dispatch(deleteSavedCardRequestAction());
		return ApiCaller.post(
			{
				...savedCardsAjaxConfig,
				headers: savedCardHeaders,
				pathname: `deletecard`,
				acceptErrors: true
			},
			payload
		).then(
			data => dispatch(deleteSavedCardSuccessAction(data)),
			err => dispatch(deleteSavedCardErrorAction(err))
		);
	};
}

export const UPDATE_SAVED_CARDS_LABEL_REQUEST = 'UPDATE_SAVED_CARDS_LABEL_REQUEST';
export const UPDATE_SAVED_CARDS_LABEL_SUCCESS = 'UPDATE_SAVED_CARDS_LABEL_SUCCESS';
export const UPDATE_SAVED_CARDS_LABEL_ERROR = 'UPDATE_SAVED_CARDS_LABEL_ERROR';

export function updateSavedCardRequestAction() {
	return { type: UPDATE_SAVED_CARDS_LABEL_REQUEST };
}

export function updateSavedCardErrorAction() {
	return { type: UPDATE_SAVED_CARDS_LABEL_ERROR };
}

export function updateSavedCardSuccessAction() {
	return { type: UPDATE_SAVED_CARDS_LABEL_SUCCESS };
}

export function updateSavedCardAction(payload) {
	return dispatch => {
		dispatch(updateSavedCardRequestAction());

		return ApiCaller.post(
			{
				...savedCardsAjaxConfig,
				headers: savedCardHeaders,
				pathname: `updatecard`,
				acceptErrors: true
			},
			payload
		).then(
			data => dispatch(updateSavedCardSuccessAction(data)),
			err => dispatch(updateSavedCardErrorAction(err))
		);
	};
}
